import l10n from '../../lib/reactPPl10nHelper';
import * as types from '../constants/ActionTypes';
import { parseEmailForm } from '../../lib/PPMEmailUtils';

const PAYPALME_REFID = 'PAYPALME001';

export const parserPayPalMeWebform = () => {
  const formFields = parseEmailForm();
  const refId = PAYPALME_REFID;
  const topicName = l10n.getContent('smarthelp/paypalmeForm.paypalform.violdation.header');

  return { formFields, refId, topicName };
};

// Provide PayPal.Me hardcode webform fields
export default () => (dispatch) => dispatch({
  type: types.PROVIDE_PPM_EMAIL_FIELDS,
  payload: parserPayPalMeWebform(),
});
